import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';

export const local: PartialCarConfiguration = {
	hasJetStream: true,
	showCaESummaryText: true,
	engineCardKeyfacts: ['acceleration', 'maxPowerHp', 'chargingTime'],
	financingDisclaimer: ['globalDisclaimer'],
	financeDomain: 'AUDI.IE',
	showFinancingDisclaimerInDialogs: true,
	nextBestActions: [
		{
			description: 'Schedule test drive',
			icon: '',
			labelText: 'Schedule test drive',
			target: '_blank',
			trackingName: 'testdrive',
			url: 'https://www.audi.ie/ie/web/en.html#layer=/ie/web/en/models/layer/book-a-test-drive.html',
		},
	],
	summaryFooterCta: {
		description: 'Audi Code',
		icon: 'code',
		labelText: 'Audi Code',
		target: '_blank',

		trackingName: 'show audicode',
		url: '',
	},
	useStaticPriceDateRemark: true,
};
